import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useEffect, useRef } from "react";

gsap.registerPlugin(ScrollTrigger);

export default function About() {
    const containerRef = useRef(null);
    const ballRef = useRef(null);

    const about = [
        {
            count: '01',
            heading: 'About Us',
            para: 'We are a creative digital agency helping brands stand out with bold, strategic, and impactful work.',
            image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=600&h=400&fit=crop'
        },
        {
            count: '02',
            heading: 'Vision',
            para: 'To lead the digital space by empowering brands to be bold and unforgettable.',
            image: 'https://images.unsplash.com/photo-1551434678-e076c223a692?w=600&h=400&fit=crop'
        },
        {
            count: '03',
            heading: 'Mission',
            para: 'To craft design-driven, result-oriented digital solutions that elevate every brand we work with.',
            image: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=600&h=400&fit=crop'
        },
        {
            count: '04',
            heading: 'Values',
            para: 'Boldness, Creativity, Integrity, Excellence, and Collaboration guide everything we do.',
            image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=400&fit=crop'
        },
        {
            count: '05',
            heading: 'What Sets Us Apart',
            para: 'We blend creativity and strategy to deliver custom digital experiences that leave a lasting impression.',
            image: 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=600&h=400&fit=crop'
        }
    ];

    useGSAP(() => {
        const cards = gsap.utils.toArray(".about-card");

        // Animate ball scroll
        gsap.to(ballRef.current, {
            scrollTrigger: {
                trigger: containerRef.current,
                scrub: true,
                start: "top 50%",
                end: "bottom 50%"
            },
            top: "100%",
            ease: "linear"
        });

        cards.forEach((card) => {
            gsap.set(card, { opacity: 0.1 });

            ScrollTrigger.create({
                trigger: card,
                start: "top center+=0",
                end: "bottom center",
                onEnter: () => gsap.to(card, { opacity: 1, duration: 0.3 }),
                onLeaveBack: () => gsap.to(card, { opacity: 0.1, duration: 0.3 })
            });
        });
    }, []);

    return (
        <>
            {/* Hero Section */}
            <section className="first px-6 py-16 max-w-6xl mx-auto">
                <div className="text-center mb-16">

                    <div className="inline-flex items-center px-4 py-2 rounded-full bg-white/60 backdrop-blur-sm border border-brand-orange/50 mb-6">
                        <span className="text-sm font-medium text-black">ABOUT US</span>
                    </div>
                    <h2 className="font-bold text-4xl md:text-6xl lg:text-7xl leading-tight mt-8">
                        Shaped by courage,<br /> driven by creativity,<br />
                        <span className="leading-[1] font-jersey block -translate-y-2 font-light text-orange-500 text-5xl md:text-7xl lg:text-8xl">
                            built to go beyond.
                        </span>
                    </h2>
                </div>
            </section>

            {/* Scrollable Content Section */}
            <section ref={containerRef} className="relative px-6 max-w-6xl mx-auto">


                {/* Content Cards */}
                <div className="space-y-16 lg:space-y-24">
                    {about.map((item, index) => (
                        <div
                            key={index}
                            className={`about-card grid lg:grid-cols-2 gap-8 lg:gap-16 items-center ${index % 2 === 0 ? 'lg:grid-flow-row' : 'lg:grid-flow-row-dense'
                                }`}
                        >
                            {/* Image */}
                            <div className={`${index % 2 === 0 ? 'lg:order-1' : 'lg:order-2'}`}>
                                <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
                                    <img
                                        src={item.image}
                                        alt={item.heading}
                                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                                    />
                                </div>
                            </div>

                            {/* Content */}
                            <div className={`${index % 2 === 0 ? 'lg:order-2' : 'lg:order-1'} space-y-6`}>
                                <div className="flex items-center space-x-4">
                                    <span className="text-orange-500 font-mono text-2xl font-bold">
                                        {item.count}
                                    </span>
                                    <div className="w-12 h-px bg-orange-500"></div>
                                </div>

                                <h3 className="text-3xl lg:text-4xl font-bold text-gray-900">
                                    {item.heading}
                                </h3>

                                <p className="text-gray-600 text-lg leading-relaxed">
                                    {item.para}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Bottom Spacing */}
            <div className="h-32"></div>
        </>
    );
}